import React from 'react';

import { RightSidebar } from "src/pages/_partials/Layout";
import { AppInterface } from "src/store/community/appsSlice";
import RowInfo from "src/componets/RowInfo";
import {UserOutlined} from "@ant-design/icons";
import Meta from "../../../../componets/Meta";

const _SidebarShow = ({ app }: { app: AppInterface | undefined }) => {
  const renderDetails = () => {
    if(!app) {
      return null;
    }

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Base Information</h6>

          <RowInfo left='#ID' right={app.id} />
          <RowInfo left='App Name' right={app.name} />
          <RowInfo left='Bundle Name' right={app.bundle_name} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>Main Bundle</h6>
      {
        app?.main_bundle_id &&
          <Meta
            url={app?.main_bundle_url}
            size='small'
            avatar={app?.bundle_icon_url || undefined}
            fallback={UserOutlined}
            title={app?.bundle_name}
            className='v-mb-20'
          />
      }

      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
